module.exports = __webpack_public_path__ + "static/media/silver.f0e86c96.svg";